/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryMoveEntryResponse
 */
export interface RevisdomAPIViewModelsEntryMoveEntryResponse {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryResponse
     */
    entryId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryResponse
     */
    entryType?: RevisdomAPIViewModelsEntryMoveEntryResponseEntryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryResponse
     */
    projectId?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryResponse
     */
    parentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryMoveEntryResponse
     */
    path?: string | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryMoveEntryResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryMoveEntryResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryMoveEntryResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryMoveEntryResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryMoveEntryResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryMoveEntryResponse(value: object): value is RevisdomAPIViewModelsEntryMoveEntryResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryMoveEntryResponseFromJSON(json: any): RevisdomAPIViewModelsEntryMoveEntryResponse {
    return RevisdomAPIViewModelsEntryMoveEntryResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryMoveEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryMoveEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'] == null ? undefined : json['entryId'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'path': json['path'] == null ? undefined : json['path'],
    };
}

export function RevisdomAPIViewModelsEntryMoveEntryResponseToJSON(json: any): RevisdomAPIViewModelsEntryMoveEntryResponse {
    return RevisdomAPIViewModelsEntryMoveEntryResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryMoveEntryResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryMoveEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'entryType': value['entryType'],
        'projectId': value['projectId'],
        'parentId': value['parentId'],
        'path': value['path'],
    };
}

